import { render, staticRenderFns } from "./memoriaal.vue?vue&type=template&id=187d0f81&scoped=true"
import script from "./memoriaal.vue?vue&type=script&lang=js"
export * from "./memoriaal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187d0f81",
  null
  
)

export default component.exports